import React, { useContext, useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  ListItemSecondaryAction,
  Tooltip
} from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import {
  NavigateNext,
  Check,
  Notifications,
  NotificationsActive
} from '@material-ui/icons/';
import Logo from 'src/components/Logo';

import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';

const useStyles = makeStyles((theme) => ({
  notificacoes: {
    position: 'relative'
  },
  avatar: {
    width: 60,
    height: 60
  },
  dropdown: {
    position: 'absolute',
    top: 56,
    right: 0,
    zIndex: 1,
    minWidth: '200px',
    width: '400px',
    border: '1px solid',
    padding: theme.spacing(1),
    color: 'black',
    backgroundColor: theme.palette.background.paper,
  },
  navegacao: {
    paddingTop: '20px',
    paddingBottom: '20px',
  }
}));

const TopBar = ({
  className,
  onMobileNavOpen,
  ...rest
}) => {
  const classes = useStyles();
  const [notifications, setNotificacoes] = useState([]);
  const [open, setOpen] = useState(false);
  const auth = useContext(AuthContext);
  const {
    sendRequest,
    // clearError
  } = useHttpClient();

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const fetchNotificacoes = async () => {
        try {
          /* const responseData = await sendRequest(
            `${process.env.REACT_APP_BACKEND_URL}/notificacoes/`,
            'GET',
            null,
            {
              'Content-Type': 'application/json',
              'x-access-token': auth.token
            }
          );

          if (responseData.sucesso) {
            setNotificacoes(responseData.data);
            console.log(responseData.data);
            clearError();
          }
          */
        } catch (err) {
          console.log(err);
        }
      };
      fetchNotificacoes();
      console.log('This will run every 120 seconds!');
    }, 120000);
    return () => clearInterval(interval);
  }, [auth]);

  const enviarModelo = async (qual) => {
    console.log(qual);
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/notificacoes/viu/${qual}`,
        'POST',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      if (response.sucesso) {
        const limpa = notifications.filter((not) => not._id !== qual);
        setNotificacoes(limpa);
        setOpen(limpa.length > 0);
        console.log(response);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const LinkBehavior = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} exact {...props} />
  ));

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      {...rest}
    >
      <Toolbar className={classes.navegacao}>
        <RouterLink to="/">
          <Logo style={{ maxWidth: '195px', width: '100%' }} />
        </RouterLink>
        <Box flexGrow={1} />
        <Hidden mdDown>
          <ClickAwayListener onClickAway={handleClickAway}>
            <div className={classes.notificacoes}>
              <IconButton color="inherit" onClick={handleClick}>
                <Badge
                  badgeContent={notifications.length}
                  color="error"
                >
                  {notifications.length > 0 ? <NotificationsActive /> : <NotificationsIcon />}
                </Badge>
              </IconButton>
              {open ? (
                <div className={classes.dropdown}>
                  <List dense>
                    {notifications.map((notificacao) => {
                      console.log(notificacao);
                      return (
                        <ListItem>
                          <ListItemAvatar>
                            <Avatar>
                              <Notifications />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={notificacao.texto}
                            secondary={notificacao.subtexto ? notificacao.subtexto : null}
                          />
                          <ListItemSecondaryAction>
                            {notificacao.botao !== null ? (
                              <Tooltip title={notificacao.botao.texto}>
                                <IconButton edge="end" aria-label="ver" to={notificacao.botao.caminho} component={LinkBehavior}>
                                  <NavigateNext />
                                </IconButton>
                              </Tooltip>
                            ) : null}
                            <Tooltip title="Marcar como lida">
                              <IconButton edge="end" onClick={() => enviarModelo(notificacao._id)} aria-label="ver">
                                <Check />
                              </IconButton>
                            </Tooltip>
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                  </List>
                </div>
              ) : null}
            </div>
          </ClickAwayListener>
          <IconButton color="inherit" onClick={auth.logout}>
            <InputIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
